import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconIosShare.tsx
const OutlinedFilledIosShare = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-10q-39.05 0-66.52-27.77Q135-65.54 135-105v-458q0-38 27.48-66 27.47-28 66.52-28h143v94H229v458h502v-458H586v-94h145q39.46 0 67.23 28Q826-601 826-563v458q0 39.46-27.77 67.23Q770.46-10 731-10H229Zm203-311v-448l-88 88-67-66 202-203 202 203-67 66-88-88v448h-94Z" })
});
const OutlinedIosShare = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-10q-39.05 0-66.52-27.77Q135-65.54 135-105v-458q0-38 27.48-66 27.47-28 66.52-28h143v94H229v458h502v-458H586v-94h145q39.46 0 67.23 28Q826-601 826-563v458q0 39.46-27.77 67.23Q770.46-10 731-10H229Zm203-311v-448l-88 88-67-66 202-203 202 203-67 66-88-88v448h-94Z" })
});
const RoundedFilledIosShare = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-10q-39.05 0-66.52-27.77Q135-65.54 135-105v-458q0-38 27.48-66 27.47-28 66.52-28h96q19.75 0 33.38 13.68Q372-629.65 372-609.82q0 19.82-13.62 33.32Q344.75-563 325-563h-96v458h502v-458h-97q-20.75 0-34.37-13.68Q586-590.35 586-610.18q0-19.82 13.63-33.32Q613.25-657 634-657h97q39.46 0 67.23 28Q826-601 826-563v458q0 39.46-27.77 67.23Q770.46-10 731-10H229Zm203-759-55 55q-14 14-33.38 14.54-19.38.54-32.81-13.5Q297-727 297-746.5t14.28-33.78L445-916q14.36-14 34.18-14T513-916l135 136q14 14.25 14 33.28 0 19.04-13.84 32.88Q634.7-700 615.38-700q-19.31 0-33.38-14l-56-55v401q0 19.75-13.68 33.37Q498.65-321 478.82-321q-19.82 0-33.32-13.63Q432-348.25 432-368v-401Z" })
});
const RoundedIosShare = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-10q-39.05 0-66.52-27.77Q135-65.54 135-105v-458q0-38 27.48-66 27.47-28 66.52-28h96q19.75 0 33.38 13.68Q372-629.65 372-609.82q0 19.82-13.62 33.32Q344.75-563 325-563h-96v458h502v-458h-97q-20.75 0-34.37-13.68Q586-590.35 586-610.18q0-19.82 13.63-33.32Q613.25-657 634-657h97q39.46 0 67.23 28Q826-601 826-563v458q0 39.46-27.77 67.23Q770.46-10 731-10H229Zm203-759-55 55q-14 14-33.38 14.54-19.38.54-32.81-13.5Q297-727 297-746.5t14.28-33.78L445-916q14.36-14 34.18-14T513-916l135 136q14 14.25 14 33.28 0 19.04-13.84 32.88Q634.7-700 615.38-700q-19.31 0-33.38-14l-56-55v401q0 19.75-13.68 33.37Q498.65-321 478.82-321q-19.82 0-33.32-13.63Q432-348.25 432-368v-401Z" })
});
const SharpFilledIosShare = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M135-10v-647h237v94H229v458h502v-458H586v-94h240v647H135Zm297-311v-448l-88 88-67-66 202-203 202 203-67 66-88-88v448h-94Z" })
});
const SharpIosShare = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M135-10v-647h237v94H229v458h502v-458H586v-94h240v647H135Zm297-311v-448l-88 88-67-66 202-203 202 203-67 66-88-88v448h-94Z" })
});
const componentMap = {
	outlined: OutlinedIosShare,
	"outlined-fill": OutlinedFilledIosShare,
	rounded: RoundedIosShare,
	"rounded-fill": RoundedFilledIosShare,
	sharp: SharpIosShare,
	"sharp-fill": SharpFilledIosShare
};
const IconIosShare = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconIosShare };